import { clientApi } from 'api';
import { ICountry } from 'server/models/HomePageCountry/types';

export const getCountries = (isServer = false) => async () => {
  const response = await clientApi.get<ICountry[]>('/countries');

  return response;
};
